<script>
export default {
  name: "Slide",

  props: {
    state:    Boolean,
    duration:  {
      type:    Number,
      default: 500,
    },
    tag:       {
      type:    String,
      default: "div",
    },
    useHidden: {
      type:    Boolean,
      default: true,
    },
  },

  data: () => ( {
    style:   {},
    initial: false,
    hidden:  false,
  } ),

  watch: {
    state() {
      this.layout();
    },
  },

  render( h ) {
    return h(
        this.tag,
        {
          style: this.style,
          attrs: this.attrs,
          ref:   "container",
          on:    { transitionend: this.onTransitionEnd },
        },
        this.$slots.default
    );
  },

  mounted() {
    this.layout();
    this.initial = true;
  },

  created() {
    this.hidden = !this.state;
  },

  computed: {
    el() {
      return this.$refs.container;
    },

    attrs() {
      const attrs = {
        "aria-hidden":   !this.state,
        "aria-expanded": this.state,
      };

      if ( this.useHidden ) attrs.hidden = this.hidden;

      return attrs;
    },
  },

  methods: {
    layout() {
      if ( this.state ) {
        this.hidden = false;
        this.$emit( "open-start" );
        if ( this.initial ) {
          this.setHeight( "0px", () => this.el.scrollHeight + "px" );
        }
      }
      else {
        this.$emit( "close-start" );
        this.setHeight( this.el.scrollHeight + "px", () => "0px" );
      }
    },

    run( callback ) {
      if ( !this.initial ) callback();
      else this.$nextTick( callback );
    },

    setHeight( temp, afterRelayout ) {
      const opacity = temp == "0px" ? 0 : 1;
      this.style = { height: temp, opacity };

      this.run(
        () => {
          // force relayout so the animation will run
          this.el.scrollHeight;

          this.style = {
            height:                 afterRelayout(),
            overflow:               "hidden",
            "transition-property":  "height opacity",
            "transition-duration":  this.duration + "ms",
            opacity:                opacity ^ 1
          };
        }
      );
    },

    onTransitionEnd( event ) {
      // Don't do anything if the transition doesn't belong to the container
      if ( event.target !== this.el ) return;

      if ( this.state ) {
        this.style = {};
        this.$emit( "open-end" );
      }
      else {
        this.style = {
          height:   "0",
          opacity:  0,
          overflow: "hidden"
        };
        this.hidden = true;
        this.$emit( "close-end" );
      }
    },
  },
};
</script>